// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","emptyFeed":"_01vAM","productCard":"vtdGE","relatedProductsArea":"_5hkxk nx-n+ ZPTkf ZDvyr kRUke mRs3u"};